module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/_utils/templates/spinner/spinner.component.css
// module id = ./src/app/shared/_utils/templates/spinner/spinner.component.css
// module chunks = main